import { Rule } from 'antd/lib/form';

export const EMAIL_RULE =
  '^[a-z][a-z0-9_.-]{5,32}@[a-z0-9]{2,}(.[a-z0-9]{2,4}){1,2}$';

// Something wrong with user@user.com

export const EMAIL_FORM_RULE: Rule[] = [
  { required: true, message: 'Please input new email!' },
  {
    type: 'email',
    message: 'Wrong email format',
  },
];

export const CONFIRM_PASSWORD_RULE: Rule[] = [
  { required: true, message: 'Please confirm your password!' },
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('password') === value) {
        return Promise.resolve();
      }
      return Promise.reject('The two passwords that you entered do not match!');
    },
  }),
];

export const CONFIRM_CHANGE_PASSWORD_RULE: Rule[] = [
  { required: true, message: 'Please confirm your password!' },
  ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject('The two passwords that you entered do not match!');
    },
  }),
];

export const TRANSFER_LINK_CHARACTER = '-';
